import React, { useState } from 'react';
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import HomeLogoLink from "../Components/Common/HomeLogoLink";

const Header = () => {
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(prev => !prev);

    return (
        <React.Fragment>
            <div className="header-area" id="headerArea">
                <div
                    className="container h-100 d-flex align-items-center justify-content-between d-flex rtl-flex-d-row-r">
                    <HomeLogoLink />
                    <div className="navbar-logo-container d-flex align-items-center">
                        <div className="d-none d-sm-block">
                            <Link to="/menu" className="btn btn-sm btn-primary d-flex align-items-center">
                                <i className="mdi mdi-silverware-fork-knife me-1"></i>
                                Menu
                            </Link>
                        </div>
                        <div
                            className="suha-navbar-toggler ms-2"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#suhaOffcanvas"
                            aria-controls="suhaOffcanvas"
                        >
                            <div onClick={() => handleShow()}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Sidebar show={show} handleShow={handleShow} />
        </React.Fragment>
    );
};

export default Header;
